import type { ApplicantStage } from "@/lib/api/applicants";

export const APPLICANT_STAGE_SEQUENCE: ApplicantStage[] = [
  "Applied",
  "Under Review",
  "Interview Invited",
  "Decision Pending",
  "Admitted",
  "Waitlisted",
  "Denied",
];

export const APPLICANT_STAGE_TOKEN: Record<ApplicantStage, string> = {
  Applied: "var(--admissions-applied)",
  "Under Review": "var(--admissions-review)",
  "Interview Invited": "var(--admissions-interview)",
  "Decision Pending": "var(--admissions-decision)",
  Admitted: "var(--admissions-admitted)",
  Waitlisted: "var(--status-warning)",
  Denied: "var(--destructive)",
};

export function tokenForApplicantStage(stage: string): string {
  return APPLICANT_STAGE_TOKEN[stage as ApplicantStage] ?? "var(--muted-foreground)";
}
